import styled, { css } from "styled-components";
import { Box, colors, darken, lighten } from "@mui/material";

import "@fontsource/story-script";
import { TemplateColorObject } from "../../../../InvitationColorMatrix";

const common_btn = (props: { colormatrix: TemplateColorObject }) => css`
	background: ${props.colormatrix.button.background};
	color: ${props.colormatrix.button.text};
	padding: 5px 15px;
	&.Mui-disabled {
		background: ${colors.grey[300]};
	}
`;

export const TemplateWrapper = styled(Box)<{ colormatrix: TemplateColorObject }>`
	overflow: hidden;

	.section_01 {
		background-image: url("https://storage.googleapis.com/public_viteslink_storage/images/invitation04/background.png");
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		position: relative;
		.section_content {
			min-height: 100vh;
			justify-content: center;
			display: flex;
			align-items: center;
			.branch_01_01_wrapper {
				position: absolute;
				top: -85px;
				right: -100px;
				transform: rotate(255deg);
				z-index: 2;
				.branch_01_01_img {
					width: 300px;
				}
			}
			.stem_01_01_wrapper {
				position: absolute;
				top: -40px;
				right: 180px;
				transform: rotate(88deg);
				z-index: 3;
				.stem_01_01_img {
					width: 100px;
				}
			}
			.stem_01_02_wrapper {
				position: absolute;
				top: -30px;
				right: 150px;
				transform: rotate(25deg);
				z-index: 3;
				.stem_01_02_img {
					width: 100px;
				}
			}

			.save_the_date_wrapper {
				display: flex;
				flex-direction: column;
				align-items: center;
				gap: 10px;
				margin: 100px 0;
				.wedding_of {
					font-family: var(--inriaSerif), sans-serif;
					font-size: 24px;
					font-weight: bold;
					color: ${props => props.colormatrix.font.primary};
					margin-bottom: 30px;
				}
				.partner_img {
					max-width: 250px;
					border-radius: 5px;
				}
				.partners_text {
					font-family: var(--story), sans-serif;
					font-weight: bold;
					font-size: 24px;
					color: ${props => props.colormatrix.font.tertiary};
				}

				.save_date_flower {
					width: 80px;
				}
				.date_wrapper {
					margin-top: 20px;
					display: flex;
					flex-direction: column;
					align-items: center;
					.date {
						font-family: var(--inriaSerif), sans-serif;
						font-size: 24px;
						font-weight: bold;
						color: ${props => props.colormatrix.font.primary};
					}
					.bottom_date_wrapper {
					}
				}
				.info {
					font-family: var(--inriaSerif), sans-serif;
					color: ${props => props.colormatrix.font.secondary};
					margin-top: 20px;
					font-size: 16px;
				}
				button {
					${common_btn};
					margin-top: 10px;
				}
			}
			.branch_01_02_wrapper {
				position: absolute;
				bottom: -110px;
				left: -105px;
				transform: rotate(155deg);
				z-index: 2;
				.branch_01_02_img {
					width: 300px;
				}
			}
		}
	}

	.section_02 {
		background: ${props => props.colormatrix.main};
		padding: 45px 30px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.title {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 28px;
			color: ${props => props.colormatrix.font.secondary};
			margin-bottom: 10px;
		}
		.count_down_wrapper {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.counter_boxes_wrapper {
				display: flex;
				padding: 10px;
				.counter_box_wrapper {
					display: flex;
					flex-direction: column;
					margin: 10px;
					align-items: center;
					.counter_box {
						color: ${props => props.colormatrix.font.secondary};
						display: flex;
						justify-content: center;
						padding: 5px 20px;
						border-radius: 5px;
						font-family: var(--inriaSerif), sans-serif;
						font-size: 32px;
						min-width: 25px;
					}
					p {
						font-family: var(--inriaSerif), sans-serif;
						font-size: 22px;
						color: ${props => props.colormatrix.font.secondary};
					}
				}
			}
		}
	}

	.section_03 {
		padding: 45px 30px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.bismillah {
			margin-bottom: 25px;
			width: 250px;
			direction: rtl;
		}
		.quran_start {
			font-family: var(--quran2);
			font-size: 22px;
			color: #000;
			text-align: center;
			font-weight: bold;
			margin-bottom: 25px;
			direction: rtl;
		}
		.quran {
			font-family: var(--quran2);
			font-size: 22px;
			color: #000;
			text-align: center;
			font-weight: bold;
			direction: rtl;
		}
		.quran_end {
			font-family: var(--quran2);
			font-size: 22px;
			color: #000;
			text-align: center;
			margin-top: 25px;
			font-weight: bold;
			direction: rtl;
		}
	}

	.section_04 {
		padding: 50px 5px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.partner_wrapper {
			border-radius: 20px;
			background: #fff;
			position: relative;
			box-shadow: 0 0 2px 2px #ebebeb;
			display: flex;
			.partner {
				max-height: 400px;
				border-radius: 20px;
			}
		}
		.initials_wrapper {
			display: flex;
			flex-direction: column;

			.top_stems {
				display: flex;
				justify-content: center;
				position: relative;
				.section_04_flower {
					width: 150px;
				}
				.top_left {
					position: absolute;
					transform: rotate(160deg);
					left: 30px;
				}
				.top_right {
					position: absolute;
					right: 28px;
					top: 40px;
					z-index: -1;
				}
				img {
					width: 200px;
				}
			}
			.initials {
				padding: 30px;
				display: flex;
				flex-direction: column;
				.divider_wrapper {
					transform: rotate(-45deg);
					hr {
						width: 165px;
						margin: auto;
					}
				}
				.partners_initial {
					font-size: 70px;
					color: ${props => props.colormatrix.font.primary};
				}
			}
			.bottom_stems {
				display: flex;
				justify-content: center;
				position: relative;
				.section_04_flower_wrapper {
					transform: rotate(90deg);
					.section_04_flower {
						width: 150px;
					}
				}

				.bottom_left {
					position: absolute;
					left: 50px;
					top: -40px;
					transform: rotate(190deg);
				}
				.bottom_right {
					position: absolute;
					right: 39px;
					top: -30px;
					z-index: -1;
					transform: rotate(288deg);
				}
				img {
					width: 200px;
				}
			}
		}
		.main_intro {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 16px;
			text-align: center;
			padding: 5px 20px;
		}
		.main_sub_intro {
			font-family: var(--inriaSerif), sans-serif;
			font-size: 22px;
			color: ${lighten("#000", 0.2)};
			margin: 15px 0;
		}
	}

	.section_05 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		background: ${props => props.colormatrix.main};
		.section_title {
			font-family: var(--inriaSerif), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 28px;
			margin-top: 35px;
		}
		.love_story_wrapper {
			width: 100%;
			display: flex;
			justify-content: center;
			position: relative;
			margin: 30px 0;

			.story_image {
				background: #fff;
				border-radius: 10px;
				max-width: 350px;
			}
		}
		.stories {
			display: flex;
			flex-direction: column;
			margin-top: 30px;
			margin-bottom: 50px;
			min-width: 330px;
			.story {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 10px 20px;
				p {
					font-family: var(--inter), sans-serif;
					font-size: 20px;
					font-weight: 400;
					text-align: center;
					color: ${props => props.colormatrix.font.secondary};
				}
				hr {
					width: 100%;
					background-color: #000;
					margin: 10px 0;
				}
				p:first-child {
					margin: 10px 0;
				}
				p:last-child {
					color: ${props => props.colormatrix.font.secondary};
				}
			}
		}
	}

	.section_06 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 10px;

		.section_title {
			font-family: var(--inriaSerif), sans-serif;
			color: ${props => props.colormatrix.font.primary};
			font-size: 32px;
		}

		.comment_text {
			font-family: var(--inter), sans-serif;
			font-size: 22px;
			padding: 5px;
		}
		.comment_sub_text {
			font-family: var(--inter), sans-serif;
			font-size: 14px;
			font-weight: 500;
			color: #000;
			text-align: center;
			padding: 0 30px;
		}
	}

	.section_07 {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		.title_wrapper {
			position: relative;
			.stem_01_wrapper {
				position: absolute;
				transform: rotate(124deg);
				top: -45px;
				left: -150px;
				z-index: -1;
				.stem_01 {
					width: 220px;
				}
			}

			.stem_02_wrapper {
				position: absolute;
				right: -150px;
				top: -45px;
				z-index: -1;
				transform: rotate(340deg);
				.stem_02 {
					width: 220px;
				}
			}

			.section_title {
				font-family: var(--inriaSerif), sans-serif;
				font-size: 30px;
				margin-top: 85px;
			}
		}

		.location_text {
			font-family: var(--inter), sans-serif;
			text-align: center;
			padding: 5px;
		}
		button {
			margin: 15px;
			${common_btn};
			padding: 10px 40px;
		}

		.partner_04_wrapper {
			border-radius: 20px;
			overflow: hidden;
			background: #fff;
			position: relative;
			width: 190px;
			height: 180px;
			box-shadow: 0 0 2px 2px #ebebeb;
			display: flex;
			.partner_04 {
				width: inherit;
				height: auto;
				position: absolute;
				left: 0;
			}
		}
		.partners_text {
			font-family: var(--story), sans-serif;
			font-weight: bold;
			//z-index: 1;
			font-size: 26px;
			color: ${props => props.colormatrix.font.primary};
		}
		.conclusion_text {
			font-family: var(--inter), sans-serif;
			font-size: 16px;
			font-weight: 500;
			text-align: center;
			padding: 10px;
		}
	}

	.section_08 {
		background: ${props => props.colormatrix.main};
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
		padding: 20px 0;

		p {
			color: ${props => props.colormatrix.font.secondary};
			margin: 10px 0;
		}
		.social {
			cursor: pointer;
			text-decoration: none;
			svg {
				path {
					fill: ${props => props.colormatrix.font.secondary};
				}
			}
		}
	}
	.section_09 {
		display: flex;
		flex-flow: column;
		align-items: center;
		position: relative;
		margin-bottom: 25px;
		padding: 10px;

		.section_title {
			font-family: var(--story), sans-serif;
			color: ${props => props.colormatrix.font.secondary};
			font-size: 32px;
			margin-top: 35px;
		}
	}
`;
